import React from 'react';
import { FormPassportContainer, FormPassportField } from '../../styles';
import { Caption2 } from '../../../../../../components/Font';
import { InputElement } from '../../../../../../ui/Input/Input';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { IRegisterForm } from '../../../../../../interface/Auth/frontend';

interface IProps {
	registerForm: IRegisterForm;
	setRegisterForm(value: IRegisterForm): void;
}

export const RuPassportNumberBlock: React.FC<IProps> = ({ registerForm, setRegisterForm }) => {
	const { t } = useTranslation();
	const Theme = useTheme();

	return (
		<FormPassportContainer>
			<FormPassportField>
				<Caption2 color={Theme.color.secondary}>{t('passport.registrationForm.passportSeriasForm.title')}</Caption2>
				<InputElement
					format={'## ##'}
					mask={' '}
					width={'100px'}
					value={registerForm.passportSeries}
					onChange={value => setRegisterForm({ ...registerForm, passportSeries: value })}
				/>
			</FormPassportField>
			<FormPassportField>
				<Caption2 color={Theme.color.secondary}>{t('passport.registrationForm.passportNumberForm.title')}</Caption2>
				<InputElement
					format={'### ###'}
					mask={' '}
					width={'114px'}
					value={registerForm.passportNumber}
					onChange={value => setRegisterForm({ ...registerForm, passportNumber: value })}
				/>
			</FormPassportField>
		</FormPassportContainer>
	);
};
